import React from "react";
import { AppBar, Grid, Button } from "@mui/material";

//... Date imports
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

const SearchFilter = ({
  fromDate,
  toDate,
  handleDateRangeChange,
  handleGoButtonClick,
  classes,
}) => {
  return (
    <AppBar
      position="sticky"
      sx={{ backgroundColor: "#ebebeb", zIndex: "1098" }}
    >
      <Grid alignItems="center" container direction="row" spacing={2} p={2}>
        <Grid item lg={1.5} md={4} sm={4} xs={4}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              id="start_Date"
              value={fromDate ? moment(fromDate) : null}
              onChange={(date) => handleDateRangeChange(date, toDate)}
              className={classes.calendarControl}
              size="small"
              label="Start Date"
            />
          </LocalizationProvider>
        </Grid>

        <Grid item lg={1.5} md={4} sm={4} xs={4}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              id="end_Date"
              value={toDate ? moment(toDate) : null}
              onChange={(date) => handleDateRangeChange(fromDate, date)}
              className={classes.calendarControl}
              size="small"
              label="End Date"
            />
          </LocalizationProvider>
        </Grid>

        <Grid item lg={1} md={4} sm={1} xs={1}>
          <Button
            variant="contained"
            sx={{ height: "fit-content" }}
            onClick={handleGoButtonClick} // Apply date range and update calendar view
          >
            GO
          </Button>
        </Grid>
      </Grid>
    </AppBar>
  );
};

export default SearchFilter;
